// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"NoticeRecordBlock--next-sr-only--HeNYUNk","baBtn":"NoticeRecordBlock--baBtn--3dPqLKJ"};